import * as actionTypes from "Application/Store/Actions/LayoutTypes"


/*****************************************************************
 *  Layout Reducer
 * ***************************************************************/

const initialState = {
    global: {
        width: window.innerWidth,
        height: window.innerHeight,
        isPortrait: window.innerWidth <= 932 && window.innerHeight > window.innerWidth,
        isMobileLandscape: window.innerWidth <= 932 && window.innerHeight <= window.innerWidth,
    },
    live: {
        open: false,
        tab: 'chat',
        minimized: true,
    },
}

/**
 * Update State
 * @param {object} state
 * @param {*} action
 * @returns
 */
export const LayoutReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.WINDOW_RESIZE:
            return {
                ...state,
                global: action.payload
            }
        case actionTypes.LIVE_TOGGLE:
            return {
                ...state,
                live: {
                    ...state.live,
                    open: !state.live.open,
                }
            }
        case actionTypes.LIVE_SET_TAB:
            return {
                ...state,
                live: {
                    ...state.live,
                    open: true,
                    tab: action.payload,
                }
            }
        case actionTypes.CLOSE_LIVE:
            return {
                ...state,
                live: {
                    ...state.live,
                    open: false,
                }
            }
        case actionTypes.LIVE_MINIMIZE:
            return {
                ...state,
                live: {
                    ...state.live,
                    minimized: action.payload,
                }
            }
        default:
            return state
    }
}
